/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Component from "@glimmer/component";
import Modifier, { PositionalArgs } from "ember-modifier";
import $ from "jquery";
export default class Progress extends Component {
  constructor(owner, args) {
    super(owner, args);
    _defineProperty(this, "updateProgress", ProgressModifier);
    this.progress = this.args.progress;
  }
}
var _isUpdated = /*#__PURE__*/new WeakMap();
class ProgressModifier extends Modifier {
  constructor(...args) {
    super(...args);
    _classPrivateFieldInitSpec(this, _isUpdated, false);
  }
  modify(progressBar, [progress]) {
    if (_classPrivateFieldGet(_isUpdated, this)) {
      $(progressBar).progress("set percent", progress);
    }
    _classPrivateFieldSet(_isUpdated, this, true);
  }
}